window.productVariants = window.productVariants || [];

document.addEventListener("DOMContentLoaded", function () {
  const COLOR_CACHE_KEY = 'illtochill_color_cache';
  const colorCache = JSON.parse(localStorage.getItem(COLOR_CACHE_KEY) || '{}');

  // Hardcoded map for speed & reliability
  const BASIC_COLOR_MAP = {
    'black': '#000000', 'jet black': '#000000', 'ink': '#000000',
    'white': '#ffffff', 'snow': '#ffffff',
    'navy': '#000080', 'dark blue': '#00008b',
    'red': '#ff0000', 'crimson': '#dc143c',
    'blue': '#0000ff', 'royal': '#4169e1',
    'sport grey': '#a9a9a9', 'grey': '#808080', 'gray': '#808080', 'heather': '#808080',
    'green': '#008000', 'forest': '#228b22',
    'sand': '#f4a460', 'beige': '#f5f5dc',
    'pink': '#ffc0cb', 'light pink': '#ffb6c1'
  };

  /* --- VISUAL FILTERING (Robust Version) --- */
  function visualFilter(isUserAction = false) {
    // 1. Identify "Color" inputs
    const fieldsets = document.querySelectorAll('.product-form__input, .variant-fieldset');
    let colorContainer = null;

    fieldsets.forEach(fs => {
      const label = fs.querySelector('.form__label, legend, .variant-label');
      if (label) {
        const txt = label.innerText.toLowerCase();
        if (txt.includes('color') || txt.includes('colour')) {
          colorContainer = fs;
        }
      }
    });

    if (!colorContainer) return; // No color option -> No filtering

    // 2. Get Selected Color
    let selectedColor = "";
    let knownColors = [];

    const checkedRadio = colorContainer.querySelector('input:checked');
    if (checkedRadio) {
      selectedColor = checkedRadio.value.toLowerCase().trim();
      const allInputs = colorContainer.querySelectorAll('input');
      knownColors = Array.from(allInputs).map(i => i.value.toLowerCase().trim());
    } else {
      const select = colorContainer.querySelector('select');
      if (select) {
        selectedColor = select.value.toLowerCase().trim();
        knownColors = Array.from(select.options).map(o => o.value.toLowerCase().trim());
      }
    }

    if (!selectedColor) return;

    // 3. Filter Media Items
    const mediaItems = document.querySelectorAll('.media-dot, .vertical-thumb');

    // Sort known matched colors by length (longest matches first) to avoid partial confusions
    knownColors.sort((a, b) => b.length - a.length);

    let firstVisibleThumb = null;

    mediaItems.forEach(item => {
      let altText = "";
      if (item.dataset.alt) {
        altText = item.dataset.alt.toLowerCase().trim();
      } else {
        const img = item.querySelector('img');
        if (img) altText = (img.alt || "").toLowerCase().trim();
      }

      if (!altText) {
        // No alt text? Always show (Generic)
        item.classList.remove('force-hide');
        if (!firstVisibleThumb) firstVisibleThumb = item;
        return;
      }

      // Check which known colors are present in this Alt Text
      // Use STRICT Regex Word Boundary check
      const presentColors = knownColors.filter(color => {
        const safeColor = color.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        const regex = new RegExp(`\\b${safeColor}\\b`, 'i');
        return regex.test(altText);
      });

      if (presentColors.length === 0) {
        // Generic image (contains NO color names) -> SHOW
        item.classList.remove('force-hide');
        if (!firstVisibleThumb) firstVisibleThumb = item;
      } else {
        // Image contains specific colors.
        // Show ONLY if the selected color is one of them.
        if (presentColors.includes(selectedColor)) {
          item.classList.remove('force-hide');
          if (!firstVisibleThumb) firstVisibleThumb = item;
        } else {
          item.classList.add('force-hide');
        }
      }
    });

    // 4. Update Main Image (Only on explicit user action)
    // This prevents "flicker" on load or polling loops.
    // If the currently displayed main image corresponds to a HIDDEN thumbnail, we MUST switch it.
    // 4. Update Main Image (Only on explicit user action)
    // This prevents "flicker" on load or polling loops.
    // If the currently displayed main image corresponds to a HIDDEN thumbnail, we MUST switch it.
    if (isUserAction && firstVisibleThumb) {
      // We only auto-switch if we are sure we should.
      const mainImg = document.querySelector('.main-media-image');
      if (mainImg) {
        // Trigger a clean switch
        // Check if we are already showing this source to avoid loop
        if (mainImg.getAttribute('src') !== firstVisibleThumb.dataset.src) {
          firstVisibleThumb.click();
        }
      }
    }
  }

  /* --- EVENT DELEGATION --- */
  document.addEventListener('click', function (e) {
    const trigger = e.target.closest('.media-dot, .vertical-thumb');
    if (trigger) {
      const newSrc = trigger.dataset.src;
      const newAlt = trigger.dataset.alt;
      const targetId = trigger.dataset.targetId || `MainImage-${sectionId}`; // Fallback if needed

      // Find main image robustly
      // We look for the ID, or fall back to class
      let mainImg = document.getElementById(targetId);
      if (!mainImg) mainImg = document.querySelector('.main-media-image');

      if (mainImg && newSrc) {
        // Prevent setting empty src
        mainImg.style.opacity = '0.5';
        setTimeout(() => {
          mainImg.src = newSrc;
          if (newAlt) mainImg.alt = newAlt;
          mainImg.style.opacity = '1';
        }, 50);

        updateActiveState(newSrc);
      }
    }
  });

  function updateActiveState(src) {
    const allNav = document.querySelectorAll('.media-dot, .vertical-thumb');
    allNav.forEach(el => {
      // Simple string match
      if (el.dataset.src === src) {
        el.classList.add('active');
        el.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      } else {
        el.classList.remove('active');
      }
    });
  }

  /* --- SETUP & LISTENERS --- */
  const variantInputs = document.querySelectorAll('input[name^="options"]');

  function handleVariantChange(e) {
    // 1. Propagate selection
    const allFieldsets = document.querySelectorAll('.variant-fieldset');
    allFieldsets.forEach(fs => {
      const radio = fs.querySelector(`input[value="${e.target.value}"]`);
      if (radio && radio.name === e.target.name) radio.checked = true;
    });

    // 2. Visual Filter (User Action = true)
    visualFilter(true);

    // 3. Update UI (Price, Buttons, Availability)
    // (Re-implementing minimal robust logic here or relying on form submission?)
    // For now, let's trust the existing form logic or simple re-check
    const fieldsets = document.querySelectorAll('.variant-fieldset');
    const selectedOptions = Array.from(fieldsets).map(fs => {
      const checked = fs.querySelector('input:checked');
      return checked ? checked.value : null;
    });

    const matched = window.productVariants.find(v => {
      return v.options.every((opt, i) => opt === selectedOptions[i]);
    });

    if (matched) {
      // Update hidden input
      const hiddenInput = document.querySelector('input[name="id"]');
      if (hiddenInput) hiddenInput.value = matched.id;

      // Update URL
      const newUrl = new URL(window.location);
      newUrl.searchParams.set('variant', matched.id);
      window.history.replaceState({}, '', newUrl);

      // Update Button
      const btn = document.querySelector('.add-to-cart-btn');
      if (btn) {
        if (matched.available) {
          btn.removeAttribute('disabled');
          btn.textContent = 'Add to bag';
        } else {
          btn.setAttribute('disabled', 'true');
          btn.textContent = 'Sold out';
        }
      }
    }
  }

  // Init
  visualFilter(false); // Initial load: filter thumbs, but DO NOT force-switch main image to avoid flicker

  // Smart Swatches (Async)
  // ... (Keep existing swatch logic if needed, or simplify) ...

  /* --- ACCORDIONS (Clean Slate) --- */
  function initAccordions() {
    const details = document.querySelectorAll('.itc-accordion');

    details.forEach(target => {
      // Use 'toggle' event which fires whenever open state changes (via click, key, or JS)
      target.addEventListener('toggle', (e) => {
        const icon = target.querySelector('.itc-icon');
        if (target.open) {
          if (icon) icon.textContent = '-';
        } else {
          if (icon) icon.textContent = '+';
        }
      });
    });
  }

  initAccordions();

  variantInputs.forEach(input => input.addEventListener('change', handleVariantChange));

});
